interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const getDefaultData = () => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '每日大赛',
          url: 'https://dairise.github.io',
          description: '每日大赛是每天不可错过的在线竞技盛宴，涵盖知识竞赛、脑力竞技、创意大赛、运动挑战、游戏竞技和音乐比赛等多个领域。',
          email: 'contact@meiridasai.com',
          telephone: '+86-400-888-9999',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '建国路88号SOHO现代城A座',
            addressLocality: '北京',
            addressRegion: '朝阳区',
            addressCountry: 'CN',
          },
          sameAs: [
            'https://weibo.com/meiridasai',
            'https://weixin.qq.com/meiridasai',
          ],
          ...data,
        };
      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '每日大赛',
          url: 'https://dairise.github.io',
          description: '每天参与竞技赢取丰厚奖励 - 在线竞技赛事平台',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: 'https://dairise.github.io/search?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
          },
          ...data,
        };
      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '每日大赛',
          description: '每日大赛 - 每天参与竞技赢取丰厚奖励',
          url: 'https://dairise.github.io',
          ...data,
        };
      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: '',
          author: {
            '@type': 'Organization',
            name: '每日大赛编辑部',
          },
          publisher: {
            '@type': 'Organization',
            name: '每日大赛',
          },
          ...data,
        };
      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [],
          ...data,
        };
      default:
        return {};
    }
  };

  const schema = { ...getDefaultData(), ...data };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}